<!-- Footer Part -->
<div class="footer-cus mt-2">
    <div class="row m-0">
        <div class="col-md-12 color-white pt-2 pb-2">
            © 2023
        </div>
    </div>
</div>
<!-- Footer Part End -->